export const PROJECT = 'business'
